export default __webpack_public_path__ + "img/f4a70db09daf33749d08d349d8e3ee3c.svg";